<!--Scroll to top-->
<button
  class="btn  btn-icon scroll-to-top bg-goalngo"
  [ngClass]="{ 'show-scroll-to-top': windowScrolled }"
  type="button"
  (click)="scrollToTop()"
  rippleEffect
>
  <span [data-feather]="'arrow-up'"></span>
</button>
